/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manage_Origins_DescriptionInputs */

const en_manage_origins_description = /** @type {(inputs: Manage_Origins_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add, edit, or remove coffee origins.`)
};

const es_manage_origins_description = /** @type {(inputs: Manage_Origins_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agrega, edita o elimina origenes de cafe.`)
};

/**
* | output |
* | --- |
* | "Add, edit, or remove coffee origins." |
*
* @param {Manage_Origins_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const manage_origins_description = /** @type {((inputs?: Manage_Origins_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manage_Origins_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_manage_origins_description(inputs)
	return es_manage_origins_description(inputs)
});